import React, { FC } from 'react';
import { PageLink, PageTitle } from '../../layout/core';
import { useTranslation } from 'react-i18next';
import { Commissions } from '../../components/agents/Commissions';

export const salesAgenciesBreadCrumbs: Array<PageLink> = [
	{
		title: 'MENU.AGENCY',
		path: '/agencies/agencies',
		isSeparator: false,
		isActive: false
	},
	{
		title: '',
		path: '',
		isSeparator: true,
		isActive: false
	}
];

export const CommissionsPage: FC = () => {
	const { t } = useTranslation();

	return (
		<>
			<PageTitle breadcrumbs={salesAgenciesBreadCrumbs}>{t('MENU.COMMISSIONS')}</PageTitle>
			<Commissions/>
		</>
	);
};